// src/keycloak.ts
import Keycloak, { KeycloakConfig } from 'keycloak-js';

/* DEV */
import config from '../../../appsettings.dev.json';

/* PROD */
// const appsettings = await fetch('/appsettings.json');
// const config = await appsettings.json();

const env = window.__ENV__ ?? null;

// Get Tenant from URL (e.g. https://tenant.example.com -> tenant), if no subdomain is present, use default tenant from config
const tenantFromUrl = window.location.hostname.split('.')[0];
const tenant =
  tenantFromUrl !== undefined && tenantFromUrl !== 'www' && tenantFromUrl !== 'localhost' && tenantFromUrl !== '' && tenantFromUrl != 'wms'
    ? tenantFromUrl
    : env != undefined && env?.AUTH_DEFAULT_REALM != undefined && env?.AUTH_DEFAULT_REALM != ''
      ? env?.AUTH_DEFAULT_REALM
      : config.auth.defaultRealm;

const keycloakConfig: KeycloakConfig = {
  url: env?.AUTH_IDP_URL || config.auth.idpUrl,
  clientId: env?.AUTH_CLIENT_ID || config.auth.clientId,
  realm: tenant,
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
